export default {
	"审卷":'审卷',
	"修改记录":'修改记录',
	"修改用户":'修改用户',
	"修改时间":'修改时间',
	"暂无记录":'暂无记录',
	"上一页":'上一页',
	"下一页":'下一页',
	"修改题目":'修改题目',
	"详细数据":'详细数据',
	"请先确认上一个产品":'请先确认上一个产品',
	"请选择地址":'请选择地址',
	"问卷视图":'问卷视图',
	"产品视图":'产品视图',
	"产品员视图":'产品员视图',
	"桌":'桌',
	"当前没有问卷进行中":'当前没有问卷进行中',
	"停留时间":'停留时间',
	"第":'第',
	"个产品":'个产品',
	"页":'页',
	"共":'共',
	"未开始":'未开始',
	"已完成":'已完成',
	"已结束":'已结束',
	"进行中":'进行中',
	"甄别问卷":'甄别问卷',
	"产品问卷":'产品问卷'
	
}